<div class="signup-form container">
    @if (isLoading) {
        <form>
            <h2>Set up authenticator</h2>
            <p class="hint-text"><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon> Loading...</p>
        </form>
    } @else if (recoveryCodes.length) {
        <form (submit)="continueToApp(); $event.preventDefault()">
            <h2>Save recovery codes</h2>
            <p class="hint-text">
                Store these codes somewhere safe. Each code works once if you lose your authenticator app. They will not be shown again.
            </p>
            <pre class="recovery-codes">{{ recoveryCodes.join('\n') }}</pre>
            <div class="form-group">
                <button type="button" class="btn btn-secondary" (click)="downloadCodes()">Download codes</button>
            </div>
            <div class="form-group">
                <label>
                    <input type="checkbox" [(ngModel)]="savedCodes" name="savedCodes" />
                    I have saved these recovery codes
                </label>
            </div>
            <div class="form-group">
                <button type="submit" class="btn btn-success" [disabled]="!savedCodes">Continue</button>
            </div>
        </form>
    } @else {
        <form (submit)="submit(); $event.preventDefault()">
            <h2>Set up authenticator</h2>
            <p class="hint-text">
                Install Microsoft Authenticator or Google Authenticator. Scan the QR code, or type the key below if you are enrolling on
                this same phone.
            </p>
            @if (qrCodeDataUrl) {
                <div class="form-group" style="text-align: center">
                    <img [src]="qrCodeDataUrl" alt="Authenticator QR code" width="180" height="180" />
                </div>
            }
            <div class="form-group">
                <label>Manual key</label>
                <input type="text" class="form-control" [value]="sharedKey" readonly />
            </div>
            <div class="form-group">
                <input
                    type="text"
                    class="form-control"
                    [(ngModel)]="code"
                    name="code"
                    placeholder="6-digit code from the app"
                    autocomplete="one-time-code"
                    inputmode="numeric"
                    required
                />
            </div>
            <div class="form-group">
                <button type="submit" class="btn btn-success" [disabled]="isSubmitting || !code">
                    @if (isSubmitting) {
                        <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Verifying</span>
                    } @else {
                        <span>Enable MFA</span>
                    }
                </button>
            </div>
            @if (sessionMissing) {
                <span style="color: red">Your sign-in expired. Please sign in again.</span>
            }
            @if (loadError) {
                <span style="color: red">Could not start MFA setup. Please sign in again.</span>
            }
            @if (rateLimited) {
                <span style="color: red">Too many attempts. Please wait and try again.</span>
            }
            @if (failed) {
                <span style="color: red">That code was not correct. Scan the latest QR or re-enter the key, then try again.</span>
            }
        </form>
        <div class="text-center">
            <a style="cursor: pointer" (click)="backToSignIn()">Back to sign in</a>
        </div>
    }
</div>
